import React from "react"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import Typography from "@material-ui/core/Typography"

import DefaultButton from "../DefaultButton"
import useStyles from "./styles"

const ConfirmationModal = ({
  title,
  children,
  open,
  onClose,
  onConfirm,
  Primeiro,
  Segundo,
  Terceiro,
  TerceiroAction,
  danger,
}) => {
  const classes = useStyles()
  return (
    <Dialog open={open} onClose={() => onClose(false)} aria-labelledby="confirm-dialog" className={classes.dialog}>
      <DialogTitle id="confirm-dialog" className={classes.title}>
        {title ? title : "Atenção"}
      </DialogTitle>
      <DialogContent className={classes.body}>
        {typeof children === "string" ? <Typography>{children}</Typography> : children}
      </DialogContent>
      <DialogActions>
        {Terceiro && (
          <DefaultButton onClick={(() => onClose(false), TerceiroAction())} stylization="text">
            {Terceiro}
          </DefaultButton>
        )}
        <DefaultButton onClick={() => onClose(false)} stylization="text">
          {Segundo ? Segundo : "Cancelar"}
        </DefaultButton>
        <DefaultButton
          stylization={danger ? "danger" : "text"}
          onClick={() => {
            onClose(false)
            onConfirm()
          }}
        >
          {Primeiro ? Primeiro : "Excluir"}
        </DefaultButton>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationModal
